<template>
    <div>
        <v-alert
            v-if="me.profile && me.profile != 'Master'"
            type="error"
        >
            Voce não possui permissão para editar a vitrine do website. Somente o perfil "Master" poderá editar. 
        </v-alert>

        <div v-else>
            <v-card
                class="mb-4 pa-4"
                outlined
            >

            <v-alert
                text
                color="orange"          
                icon="mdi-alert-outline"    
            >
                <span class="black--text">
                    A vitrine do website é composta de titulos o qual voce poderá relacionar a lista de imóveis.
                    <br /> 1 - Crie o título (procure não cadastrar frases extensas);
                    <br /> 2 - Após a criação do título clique em "Vincular imóveis". Informe o código e clique em adicionar;

                    <!--a href="https://www.youtube.com/watch?v=LduzEgnsS2c" target="_blank">Video tutorial</a--> 
                </span> 
            </v-alert>

            <v-form ref="form" class="p-2">
                <v-row dense>
                    <v-col cols="12" xs="12" sm="12" md="5" lg="5" xl="5">
                        <v-text-field
                            v-model="localItem.title"
                            :rules="[rules.required]"
                            outlined
                            dense
                            required
                            :class="$css_field"
                        >
                            <template v-slot:label>
                                <span :class="$css_field">Título</span>
                            </template>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                        <v-select
                            v-model="localItem.type"
                            :items="items.type"
                            :rules="[rules.required]"
                            outlined
                            dense
                            :class="$css_field"
                        >
                            <template v-slot:label>
                                <span :class="$css_field">Tipo</span>
                            </template>
                        </v-select>
                    </v-col>
                    <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                        <v-text-field
                            v-model="localItem.order"
                            label="Número"
                            :rules="[rules.required]"
                            type="number"
                            outlined
                            dense
                            :class="$css_field"
                        >
                            <template v-slot:label>
                                <span :class="$css_field">Ordem</span>
                            </template>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                        <v-btn
                            color="primary"
                            @click="validate"
                            :class="$css_button"
                        >
                            <span v-if="localItem.id">Editar</span>
                            <span v-else>Adicionar</span>
                        </v-btn>
                    </v-col>  
                </v-row>
            </v-form>
            </v-card>
        </div>

        <div v-for="(shop_window, index) in shop_windows" :key="index" class="mb-4">
            <v-expansion-panels
            v-model="expandedPanels[index]"
            class="mt-2"
            flat
            tile
            style="border: 1px solid #ddd;"
            >
            <v-expansion-panel>
                <v-expansion-panel-header disable-icon-rotate class="pa-4">
                    <div
                        :class="
                        $vuetify.breakpoint.smAndDown
                            ? 'font-weight-bold caption'
                            : 'font-weight-bold text-h6'
                        "
                    >
                        {{ shop_window.title }}
                    </div>
                    <v-spacer v-if="$vuetify.breakpoint.mdAndUp" />
                    

                    <template v-slot:actions>
                        <br />
                        <div>
                            <!-- Botão Editar: NÃO abre o painel -->
                            <v-btn
                                :class="$css_button"
                                :small="$vuetify.breakpoint.smAndDown"
                                depressed
                                outlined
                                @click.stop.prevent="editItem(shop_window.id)"
                            >
                                <v-icon left>mdi-pencil</v-icon>
                                <span v-if="!$vuetify.breakpoint.smAndDown">Editar</span> 
                            </v-btn>

                            <!-- Botão Excluir: NÃO abre o painel -->
                            <v-btn
                                :class="$css_button + ' ml-2'"
                                :small="$vuetify.breakpoint.smAndDown"
                                depressed
                                outlined
                                @click.stop.prevent="destroyItem(shop_window.id)"
                            >
                                <v-icon left>mdi-trash-can-outline</v-icon> 
                                <span v-if="!$vuetify.breakpoint.smAndDown">Excluir</span> 
                            </v-btn>

                            <!-- Botão "Vincular imóveis": ABRE o painel -->
                            <v-btn
                                :class="$css_button + ' ml-2'"
                                :small="$vuetify.breakpoint.smAndDown"
                                depressed
                                outlined
                                @click.stop.prevent="openPanel(index)"
                                color="pink"
                            >
                                <v-icon left color="pink">mdi-home</v-icon> 
                                <span v-if="!$vuetify.breakpoint.smAndDown">Vincular imóveis</span> 
                            </v-btn>
                        </div>
                    </template>
                </v-expansion-panel-header>

                <v-expansion-panel-content>
                    <card-property-vertical-shop-window :property_relations="shop_window.property_relations" :item_id="shop_window.id" />
                </v-expansion-panel-content>
            </v-expansion-panel>
            </v-expansion-panels>
        </div>
       
    </div>
</template>

<script>
import { TYPE_ITEMS } from '@/components/shop_windows/config_shop_windows/config_shop_windows.js' 
import CardPropertyVerticalShopWindow from './CardPropertyVerticalShopWindow.vue';

export default {
    name: 'ShopWindow',

    components: {
        CardPropertyVerticalShopWindow
    },
    
    mounted() {
        window.scrollTo(0, 0);
        this.shopWindows();
    },

    computed: {
        me () {
            return this.$store.state.auth.me
        }
    },

    data () {
        return {
            localItem: {
                id: null,
                title: '',
                type: '',
                order: null,
            },

            rules: {
                required: value => !!value || 'Campo obrigatório.',
            },

            items: {
                type: TYPE_ITEMS
            },

            shop_windows: [],

            expandedPanels: [],
            loadIframe: false,
        }
    },  
    
    watch: {
        shop_windows: {
            handler(newVal) {
                // Sempre que shop_windows mudar, ajusta expandedPanels
                this.expandedPanels = new Array(newVal.length).fill(null);
            },
            immediate: true, // executa na inicialização (mesmo que shop_windows seja [])
        }
    },

    methods: {
        async shopWindows() {
            try {
                const response = await this.$store.dispatch('loadPromisseShopWindow');
                this.shop_windows = response.data;
            } catch (error) {
                console.error('Erro ao carregar propriedades:', error);
                // Opcional: exibir mensagem ao usuário
                this.$toast.error('Falha ao carregar os dados. Tente novamente.');
            }
        },

        validate () {
            if (this.$refs.form.validate()) {       
                this.storeUpdate()
            }
        },

        storeUpdate(){
            
            const action = this.localItem.id ? 'updateShopWindow' : 'storeShopWindow'
            this.$store.dispatch(action, this.localItem)
                        .then(response => {
                            const result = response.data
                            // Verifica se já existe um colaborador com o mesmo id no array
                            const index = this.shop_windows.findIndex(c => c.id === result.id);

                            if (index > -1) {
                                this.$set(this.shop_windows, index, result); 
                            } else {
                                this.shop_windows.push(result);
                            }

                            this.shop_windows.sort((a, b) => a.order - b.order);

                            this.$snotify.success('Cadastrado com sucesso!')
                            this.reset()
                        })
                        .catch(error => {   
                            this.$snotify.error('Erro no cadastro');
                        })
        },

        editItem (id) {    
            this.$store.dispatch('loadShopWindow', id) 
                        .then(response => {
                            this.localItem = response.data
                        })
        },

        destroyItem(id){
            this.$store.dispatch('destroyShopWindow', id)
                        .then(response => {
                            // Encontra o índice do colaborador no array
                            const index = this.shop_windows.findIndex(c => c.id === id);

                            if (index > -1) {
                                // Remove reativamente do array
                                this.shop_windows.splice(index, 1);
                            }
                        })
                        .catch(error => {
                            this.$snotify.error('Erro no cadastro');
                        })
                        .finally(
                            //this.$snotify.remove()
                            this.$snotify.success('Registro excluído com sucesso!')
                        )
        },

        reset(){
            this.local = {
                id: null,
                title: '',
                type: '',
                order: null,
            }
            this.$refs.form.reset()
        },

        openPanel(index) {
            const currentState = this.expandedPanels[index];
            // Se estiver aberto (0), fecha (null); se estiver fechado (null/false), abre (0)
            this.$set(this.expandedPanels, index, currentState === 0 ? null : 0);
            this.loadIframe = currentState !== 0; // opcional: só ativa loadIframe ao abrir
        },
    }    

}
</script>